import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { LoanRequestMessageComponent } from 'src/app/MessageClipboard/loan-request-message/loan-request-message.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { LoanRequest } from 'src/model/loanRequest.model';

@Component({
    selector: 'app-edit-loan-request-remark',
    templateUrl: './edit-loan-request-remark.component.html',
    styleUrls: ['./edit-loan-request-remark.component.scss'],
    standalone: false
})
export class EditLoanRequestRemarkComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);

  @Input() request: LoanRequest;
  remark = "";
  disabledSubmit = false;

  ngOnInit(): void {
    this.remark = (this.request.Remark.split("=").length > 1) ? this.request.Remark.split("=")[0] : this.request.Remark;
  }

  submit() {
    if (this.remark == "")
      this.sharedService.openAlert("Please fill in remark", ALERT_TYPE.DANGER);
    else if (this.remark == this.request.Remark) {
      this.sharedService.openAlert("Nothing updated in the remark", ALERT_TYPE.DANGER);
    }
    else {
      this.updateLoanRequestRemark();
    }
  }

  updateLoanRequestRemark() {
    const remark = (this.request.Remark.split("=").length > 1) ? this.remark + "=" + this.request.Remark.split("=")[1] : this.remark;
    const data = {
      "remark": remark
    }

    const xhr = this.restApi.putRequest(this.constructApi.getUpdateEPFRequestRemark(this.request.ID), data)
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        //if success , then proceed
        if (xhr.status == 200) {
          const json = JSON.parse(xhr.responseText);
          this.request.ID = Number(json.id);

          this.request.Remark = remark;
          if (this.sharedService.isBranchManager()) {
            const modalRef = this.sharedService.openModal(LoanRequestMessageComponent);
            modalRef.componentInstance.request = this.request;
            modalRef.componentInstance.isDirty = true;

            this.reset();
          }
          else
            window.location.reload();
        }
        else {
          //show error message
          this.sharedService.openAlert(JSON.parse(xhr.responseText).error, ALERT_TYPE.DANGER)
        }
      }
    }
  }

  reset() {
    this.activeModal.close();
  }
}
